<nz-space class="mobile-report-control">
  <app-area-select [showAddNewButton]="false" [(ngModel)]="from" class="report-control"
    (ngModelChange)="fromChange.emit($event)" valueField="code" [type]="'supplier'" [activeOnly]="false">
  </app-area-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-area-select [showAddNewButton]="false" [(ngModel)]="to" class="report-control"
    (ngModelChange)="toChange.emit($event)" valueField="code" [type]="'supplier'" [activeOnly]="false">
  </app-area-select>
</nz-space>